/** @format */

import EdilentWorkerApi from '@model/api';
import Validator from '@croco/validator';
import di        from "dependency-injection";

/**
 * 
 *
 * @package     edilent-worker
 * @author      Yujiro Takahashi <yujiro@cro-co.co.jp>
 */
class WorksWithApi extends EdilentWorkerApi
{
    /**
     * コンストラクタ
     *
     * @access public
     * @return void
     */
    constructor() {
//        super('mock');    // モックの有効
        super('public-info');

        this.page = "list";
        this.list = [];
        this.masters = [];
        this.otherId = null;
        this.isRegistered = false;
        this._clear();

        this._registerEvent();
    }

    /**
     * バリデーションの取得
     *
     * @access public
     * @return void
     */
    getValidation(name) {
        let validation = new Map([
            ['title',   {required: true,  validate:false}], 
            ['url',     {required: false, validate:'url'}], 
            ['fields',  {required: false, validate:false}], 
            ['other',   {required: false, validate:false}], 
            ['comment', {required: true,  validate:false}],
            ['limited_publish_level', {required: false,  validate:false}],
        ]);
          
        if ('other' == name) {
            let key = 'fields_' + this.otherId;
            if (key in this.item) {
                if (this.otherId == this.item[key]) {
                    validation.set('other', {required: true,  validate:false});
                } else {
                    validation.set('other', {required: false,  validate:false});
                }
            }
        }

        if (validation.has(name)) {
            return validation.get(name);
        }
        const column = name.split('_');

        if (validation.has(column)) {
            return validation.get(column);
        }
        return {required: false, validate:false};
    }

    /**
     * 担当分野の選択済数の確認
     *
     * @access private
     * @return bool
     */
    hasFields() {
        let keys = Object.keys(this.item);
        keys = keys.filter(key => {
            return ('fields' === key.substr(0, 6))
        });
        let array = [];
        for (let idx in keys) {
            if (this.item[keys[idx]]) {
                array.push(this.item[keys[idx]]);
            }
        } // for (let key of itor)
        if (0 == array.length) {
            this.fieldsAlert = true;
        } else {
            this.fieldsAlert = false;
        }
        return this.fieldsAlert;
    }

    /**
     * 変数の初期化
     *
     * @access private
     * @return void
     */
    _clear() {
        this.id = null;
        this.item = new Validator({
            title:   '',
            url:     '',
            other:   '',
            comment: '',
            limited_publish_level: ''
        });
        this.thumbFile = null;
        this.workFile = null;
        this.otherReadonly = 'readonly';
        this.ogpDisplay = 'none';
        this.fieldsAlert = true;

        this.ogp_action = '';
        this.thumb_action = '';
        this.work_action = '';
    }

    /**
     * イベントの登録
     *
     * @access private
     * @return void
     */
    _registerEvent() {
        this.on('list', ()=> {
            this._list();
        });
        this.on('fetch', (id = null)=> {
            this._fetch(id);
        });
        this.on('register', ()=> {
            this._register();
        });


        this.on('set:url', (url, valid)=> {
            if (valid) {
                if (0 == url.length) {
                    this.ogpDisplay = 'none';
                    this.ogp_action = '';
                } else {
                    this.ogpDisplay = 'body';
                }
            } else {
                this.ogpDisplay = 'none';
                this.ogp_action = '';
            }
            this.trigger('update');
        });

        this.on('set:fields', (id, valid)=> {
            this.hasFields();
            this.trigger('update');
        });

        this.on('set:fields_8', (id)=> {
            if (id) {
                this.otherReadonly = '';
            } else {
                this.item.set('other', '', {validate: false});
                this.otherReadonly = 'readonly';
                this.trigger('setValid:other', true);
            }
            this.trigger('update');
        });
    }

    /**
     * 担当分野：マスター項目の取得
     *
     * @access private
     * @return void
     */
    _setMasters(fields) {
        if (0 != this.masters.length) {
            return;
        }
        let rows = [];
        for (let field of fields) {
            if (!field.other) {
                rows.push({
                    id: field.id,
                    label: field.jname
                });
                if (0 == (rows.length % 3)) {
                    this.masters.push(rows);
                    rows = [];
                }
            } else {
                this.otherId = field.id;
            }
        }
    }

    /**
     * 制作実績一覧の取得
     *
     * @access private
     * @return void
     */
    async _list() {
        this.page = 'list';
        let list = await this.request('works', 'list');
        this.list = [];
        this.isRegistered = !!list;

        for (let idx in list) {
            let files = '';
            let thumbnail = '';
            if (null != list[idx].files) {
                files = list[idx].files['hash'];
            }
            if (null != list[idx].thumbnail) {
                thumbnail = list[idx].thumbnail['hash'];
            }
            this.list.push({
                comment: list[idx].comment,
                files: files,
                id: list[idx].id,
                in_charge_fields: list[idx].in_charge_fields,
                thumbnail: thumbnail,
                title: list[idx].title,
                url: list[idx].url
            });
        }
        this.trigger('update');
    }

    /**
     * 指定した制作実績の取得
     *
     * @access private
     * @return void
     */
    async _fetch(id) {
        this._clear();
        this.id = id;

        this.page = 'form';
        let item = await this.request('works', 'fetch', {work_id: id});
        this._setMasters(item.in_charge_field_masters);

        this.ogp_action = '';
        this.thumb_action = '';
        this.work_action = '';

        if (null == id) {
            this.trigger('setValid:title', false);
            this.trigger('setValid:comment', false);
            this.trigger('update');
            return ;
        }

        this.item.set('title',   item.works.title,   {required: true, validate:false});
        this.item.set('url',     item.works.url,     {validate: 'url'});
        this.item.set('comment', item.works.comment, {required: true, validate:false});
        this.item.set('limited_publish_level', item.works.limited_publish_level, {required: true, validate:false});
        if (0 !== item.works.url.length) {
            this.ogpDisplay = 'body';
        }

        let in_charge_fields_memo_other = '';
        if (null !== item.in_charge_fields) {
            for (let field of item.in_charge_fields) {
                let master_id = field.in_charge_field_master_id;
                this.item.set('fields_'+ master_id, master_id, {validate: false});
                if (this.otherId == master_id) {
                    in_charge_fields_memo_other = field.memo;
                    this.otherReadonly = '';
                }
            } // for (let field of item.in_charge_fields)  
        } // if (null !== item.in_charge_fields)
        this.item.set('other', in_charge_fields_memo_other, {validate: false});
        this.hasFields();

        this.thumbnail = item.thumb_image_hash;
        if (typeof item.work_file_hash !== 'undefined') {
            if (null !== item.work_file_hash && 0 !== item.work_file_hash.length) {
                this.work_file = item.work_file_name;
                if (0 === item.work_file_name.length) {
                    this.work_file = 'works.pdf';
                }
            }
        } // if (typeof item.work_file_hash !== 'undefined')

        this.item.validate();
        this.trigger('update');
    }

    /**
     * 制作実績の登録/更新
     *
     * @access private
     * @return void
     */
    async _register() {
        this.enable = this.item.validate();
        if (!this.enable) {
            this.trigger('update');
            return ;
        }
        if (this.hasFields()) {
            this.trigger('update');
            return ;
        }
        let data = new FormData();

        let work_id = this.id;
        if (null === this.id) {
            work_id = 0;
        }
        data.set('work_id', work_id);
        data.set('title', this.item.title);
        data.set('url', this.item.url);
        data.set('in_charge_fields_memo_other', this.item.other);
        if (null !== this.thumbFile) {
            data.set('thumb_image', this.thumbFile);
            this.thumb_action = 'update';
        }
        if (null !== this.workFile) {
            data.set('work_file', this.workFile);
            this.work_action = 'update';
        }
        data.set('comment', this.item.comment);
        data.set('limited_publish_level', this.item.limited_publish_level);
        data.set('ogp_action', this.ogp_action);
        data.set('thumb_action', this.thumb_action);
        data.set('work_action', this.work_action);

        let keys = Object.keys(this.item);
        keys = keys.filter(key => {
            return ('fields' === key.substr(0, 6))
        });

        let fidx = 0;
        for (let idx in keys) {
            if (this.item[keys[idx]]) {
                data.set('in_charge_fields['+ fidx +']', this.item[keys[idx]]);
                fidx++;
            }
        } // for (let key of itor)

        await this.request('works', 'register', data);
        if (!this.isRegistered) {
            window.analytics.event("unlock_achievement", {
                achievement_id: "works_first_registration",
            });
        }
        this._list();

        if (null === this.id) {
            di.toast.push(`[${this.item.title}]を登録しました。`, "success");
        } else {
            di.toast.push(`[${this.item.title}]を更新しました。`, "success");
        }
        this.trigger('clear-img');
        this.trigger('clear-pdf');
    }
} // class WorkWithEmitter extends Emitter

const worksApi = new WorksWithApi();

export default worksApi;
